import styled from 'styled-components';
export const CollapseBodyWrapper = styled.div `
  ${({ $duration, $height, $isExpanded, $transitionHasEnded }) => `
    overflow: ${$transitionHasEnded && $isExpanded ? 'visible' : 'hidden'};
    height: ${$isExpanded ? `${$height}px` : '0'};
    transition: height ${$duration}s ease-in-out;
  `}
`;
export const CollapseContainer = styled.div `
  ${({ $isExpanded, $duration }) => !$isExpanded &&
    `
    visibility: hidden;
    transition:visibility ${$duration}s ease-in-out;
  `}
`;
//# sourceMappingURL=subcomponents.js.map